<template>
	<v-layout>
		<v-container
			class="fill-height"
			fluid
		>
			<v-row
				align="center"
				justify="center"
			>
				<v-col class="text-center">
					<span class="code">{{ error.statusCode }}</span>
					<span
						class="message"
						style="padding: 10px;"
					>{{
						error.statusCode === 404 ? pageNotFound : otherError
					}}</span>
				</v-col>
			</v-row>
		</v-container>

		<client-only>
			<cookie-law
				theme="blood-orange"
				button-text="ยอมรับ"
				message="เว็บไซต์ของ THE BEST PROPERTY AGENT ใช้คุกกี้เพื่อให้เว็บไซต์ทำงานได้อย่างถูกต้อง และช่วยปรับปรุงประสบการณ์การใช้งานของคุณเท่านั้น เราไม่ใช้คุกกี้เพื่อเก็บข้อมูลส่วนบุคคล หรือเพื่อติดตามการใช้งานของคุณในเชิงโฆษณา การกดปุ่ม “ยอมรับ” หมายถึงคุณยอมรับการใช้งานคุกกี้พื้นฐานที่จำเป็นต่อการทำงานของเว็บไซต์เท่านั้น"
			/>
		</client-only>
	</v-layout>
</template>

<script>
export default {
	components: {
		CookieLaw: () => process.client ? import('vue-cookie-law') : null
	},
	props: {
		error: {
			type: Object,
			default: null
		}
	},
	data() {
		return {
			pageNotFound: '404 Not Found',
			otherError: 'An error occurred'
		}
	},
	head() {
		const title =
			this.error.statusCode === 404 ? this.pageNotFound : this.otherError
		return {
			title
		}
	}
}
</script>

<style lang="scss" scoped>
.code {
	border-right: 2px solid;
	font-size: 26px;
	padding: 0 15px 0 15px;
	text-align: center;
}
.layout {
	height: 100vh;
}
.message {
	font-size: 18px;
	text-align: center;
}
</style>
